import * as assignUsersActions from './assignUsers/actions';
import * as chargeLimitActions from './chargeLimit/actions';
import * as enrollmentActions from './enrollment/actions';
import * as pageActions from './page/actions';
import * as servedItemsActions from './servedItems/actions';
import * as settingsActions from './settings/actions';
import * as siteDetailsActions from './siteDetails/actions';
import * as assignItemsActions from './assignItems/actions';
import { SITESETUP_CLEAR_FETCHED } from './types';

export const actions = {
  ...assignUsersActions,
  ...chargeLimitActions,
  ...enrollmentActions,
  ...pageActions,
  ...servedItemsActions,
  ...settingsActions,
  ...siteDetailsActions,
  ...assignItemsActions,
  clearFetched: () => {
    return {
      type: SITESETUP_CLEAR_FETCHED,
    };
  },
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/actions.js